import React from "react";
import { Col, Row } from "react-bootstrap";
import { motion } from "framer-motion";
import HireUsModal from "./HireUsModal";

const processSteps = [
  {
    step: "01",
    title: "Discovery",
    desc: "We understand your business, workflows, and pain points through a detailed consultation.",
  },
  {
    step: "02",
    title: "Design",
    desc: "Our team architects the solution — UI/UX, database, AI models, and system design.",
  },
  {
    step: "03",
    title: "Build & Ship",
    desc: "We develop, test, and deploy your custom software with AI capabilities baked in.",
  },
  {
    step: "04",
    title: "Support & Scale",
    desc: "Ongoing maintenance, feature updates, and scaling support as your business grows.",
  },
];

function ConsultComponent() {
  return (
    <div className="process-section-new">
      <div className="container">
        <motion.div
          className="text-center"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="section-badge">How We Work</div>
          <h3>
            From Idea to <span style={{ color: "#63FFCD" }}>Launch</span>
          </h3>
          <p className="process-subtitle">
            Our streamlined process ensures your project goes from concept to
            production efficiently.
          </p>
        </motion.div>

        <Row className="process-grid">
          {processSteps.map((s, i) => (
            <Col xs={12} md={6} lg={3} key={s.step}>
              <motion.div
                className="process-card-new"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: i * 0.15 }}
              >
                <span className="process-step-num">{s.step}</span>
                <h5 className="process-step-title">{s.title}</h5>
                <p className="process-step-desc">{s.desc}</p>
                {i < processSteps.length - 1 && (
                  <div className="process-connector" />
                )}
              </motion.div>
            </Col>
          ))}
        </Row>

        <motion.div
          className="text-center"
          style={{ marginTop: "40px" }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.6 }}
        >
          <HireUsModal />
        </motion.div>
      </div>
    </div>
  );
}

export default ConsultComponent;
